import './midtermTransaction.scss';
import './cancellation-details.scss';

import {
  CreateMidtermTransactionField,
  getMidtermTransactionFieldProps,
} from '@converge/data';
import {
  NewDateField,
  NewFormTextField,
} from '../../../../presentation/components';

import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export interface WaiverChangeControlDetailsProps {
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  effectiveDate?: string;
  maxDate?: Date;
}

export const WaiverChangeControlDetails = ({
  setIsDisabled,
  effectiveDate,
  maxDate,
}: WaiverChangeControlDetailsProps) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    setValue(CreateMidtermTransactionField.DateOfAcquisition, effectiveDate);
  }, [setValue, effectiveDate]);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Get form values and watch for changes
  const legalName = watch(CreateMidtermTransactionField.LegalName);
  const dateOfAcquisition = watch(
    CreateMidtermTransactionField.DateOfAcquisition
  );

  useEffect(() => {
    // Disable the button if legal name is empty or if there are validation errors
    const legalNameEmpty = !legalName || legalName.trim().length === 0;
    const hasErrors = Object.keys(errors).length > 0;

    setIsDisabled(legalNameEmpty || hasErrors);
  }, [legalName, dateOfAcquisition, errors, setIsDisabled]);

  return (
    <Box
      className="cancellation-details"
      sx={{ display: 'flex', flexDirection: 'column', gap: 3, height: '530px' }}
    >
      <Box>
        <Typography className="cancellation-details__section-title">
          What is the legal name of the acquiring entity?
        </Typography>
        <NewFormTextField
          {...getMidtermTransactionFieldProps(
            CreateMidtermTransactionField.LegalName
          )}
          label=""
          placeholder="Enter Legal Name"
          dataTestId="legal-name-input"
        />
      </Box>
      <Box>
        <Typography
          className="cancellation-details__section-title"
          style={{ marginTop: '30px' }}
        >
          What is the date of acquisition?
        </Typography>
        <Box style={{ width: '300px' }}>
          <NewDateField
            {...getMidtermTransactionFieldProps(
              CreateMidtermTransactionField.DateOfAcquisition
            )}
            label=""
            data-testid="date-of-acquisition-input"
            minDate={today}
            maxDate={maxDate}
            disabled={false}
          />
        </Box>
      </Box>
    </Box>
  );
};
